import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { profilePagePath } from 'routes/paths';
import { MdOutlineHelpOutline } from 'react-icons/md';
import useConfig from 'hooks/useConfig';

interface Props {
    handleLogout: () => void;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfileTab = ({ handleLogout, setOpen }: Props) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const navigate = useNavigate();
    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement>, index: number) => {
        setSelectedIndex(index);
        if (index === 1) {
            navigate(profilePagePath());
        }
    };
    const { onChangeshowBuilderGuide } = useConfig();
    const icons = {
        MdOutlineHelpOutline: MdOutlineHelpOutline as React.ElementType,
    };
    return (
        <List component='nav' sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
            <ListItemButton
                selected={selectedIndex === 1}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1)}>
                <ListItemIcon>
                    <UserOutlined />
                </ListItemIcon>
                <ListItemText primary='View Profile' />
            </ListItemButton>
            <ListItemButton
                onClick={() => {
                    onChangeshowBuilderGuide(true), setOpen(false);
                }}>
                <ListItemIcon>
                    <icons.MdOutlineHelpOutline size={20} />
                </ListItemIcon>
                <ListItemText primary='Show Guide' />
            </ListItemButton>
            <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutOutlined />
                </ListItemIcon>
                <ListItemText primary='Logout' />
            </ListItemButton>
        </List>
    );
};

export default ProfileTab;
